import { render } from "./PostSortItem.vue?vue&type=template&id=fc5f693c"
import script from "./PostSortItem.vue?vue&type=script&lang=js"
export * from "./PostSortItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__